
































import BaseComponent from '@/core/base.component';
import { Component, Prop } from 'vue-property-decorator';
import QNAService from '@/services/qna.service';
import { QNACreateDto } from '@/dto/qna';
import { CONST_INQUIRY_TYPE } from '@/services/shared/common-code.type';
import codeManagementService from '@/services/init/code-management.service';
import { CodeManagementDto } from '@/services/init/dto';
@Component({
  name: 'QNAddDialog',
})
export default class QNAddDialog extends BaseComponent {
  @Prop({ required: true }) readonly dialog: boolean;
  private loading = false;
  private QNACreateDto = new QNACreateDto();
  private QNASelectionList: CodeManagementDto[] = [];

  add() {
    this.loading = true;
    QNAService.create(this.QNACreateDto).subscribe(
      res => {
        this.loading = false;
        this.reset();
        this.$emit('added');
      },
      err => {
        this.loading = false;
      },
    );
  }
  reset() {
    // this.userAddDialog = false;
    this.$emit('update:dialog', !this.dialog);
    this.loading = false;
    this.QNACreateDto = new QNACreateDto();
  }
  toggle() {
    this.$emit('update:dialog', !this.dialog);
  }
  getInquiryTypeList() {
    codeManagementService.findInquiryType().subscribe(res => {
      this.QNASelectionList = res.data;
    });
  }
  created() {
    this.getInquiryTypeList();
  }
}
